<template>
  <div class="handbook-step-wrapper" v-if="application">
    <div class="uk-grid" v-if="applicant">
      <div class="uk-width-1-1 uk-align-center uk-margin-bottom">
        <h4 align="center">
          I acknowledge receipt and understanding of the CUL Student Handbook for my participation in the Ready2Earn program.
          I can always request another copy should I need one.
        </h4>
        <!-- <div class="uk-margin-bottom"><a href="/downloads/programs/job/Handbook-Gen_Rel_and_Ackn.pdf" target="_blank"
            class="uk-button uk-button-default uk-button-large uk-width-1-1"><i class="a-download-2"></i>
            Download Student Handbook PDF file</a></div> -->
        <div class="uk-margin-top">
          <embed type="application/pdf"
            :src="handbookUrl"
            width="100%"
            height="800">
        </div>
      </div>
      <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2 uk-margin-large-top" v-if="!userIsStudent">
        <h3>Parent Signature:</h3>
        <validated-section :field="'signature_' + applicant.id" :errors="errors">
          <signature-box @updated="onSignatureUpdated" :user-key="applicant.id"
            :is-signed="signatureData[applicant.id] && signatureData[applicant.id].signed_at !== null"
            :completed="signatureData[applicant.id] && signatureData[applicant.id].completed"
            :name="applicant.first_name + ' ' + applicant.last_name"
            :color="programSettings['primary-program-color']"></signature-box>
        </validated-section>
      </div>
      <br />
      <hr />
      <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2 uk-margin-large-top">
        <h3>Student Signature:</h3>
        <validated-section :field="'signature_' + student.id" :errors="errors">
          <signature-box @updated="onSignatureUpdated" :user-key="student.id"
            :is-signed="signatureData[student.id] && signatureData[student.id].signed_at !== null"
            :completed="signatureData[student.id] && signatureData[student.id].completed"
            :name="student.first_name + ' ' + student.last_name"
            :color="programSettings['primary-program-color']"></signature-box>
        </validated-section>
      </div>
    </div>

    <p style="color: red;" id="footer-error"></p>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
// import moment from 'moment'
import SignatureBox from "./../../../../../../../components/AppWizard/SignatureBox";
import ValidatedSection from "./../../../../../../../components/Common/ValidatedSection";

export default {
  name: "HandbookStep",
  props: {
    print: {
      type: Boolean,
      default: false,
    }
  },
  components: { ValidatedSection, SignatureBox },
  data() {
    return {
      errors: {},
      loading: false,
      signatureData: {},
    }
  },

  mounted() {
    if (this.application) {
      this.initData();
    }
  },

  watch: {
  },

  computed: {
    user() {
      return this.$store.getters['App/user']
    },

    handbookUrl() {

      let docCategory = _.find(this.documentCategories, {key: 'job_handbook'});
      if(docCategory && docCategory.attestations.length) {
        return docCategory.attestations[0].url;
      }

      return '/downloads/programs/job/Handbook-Gen_Rel_and_Ackn.pdf';
    },

    ...mapState('Application', {
      application: 'application',
      applicant: 'applicant',
      signatures: 'signatures',
      userIsStudent: 'userIsStudent',
      documentCategories: state => state.assets.documentCategories,
    }),
    ...mapGetters('Application', ['programSettings', 'student']),
  },

  methods: {
    initData() {
      const applicantSignatureFiltered = this.applicant && this.applicant.signatures && this.applicant.signatures.find(item => item.key === `app-jobs-handbook`)
      if (applicantSignatureFiltered && this.applicant) {
        this.$set(this.signatureData, this.applicant.id, { signed_at: applicantSignatureFiltered.created_at, completed: true });
      }
      const signatureFiltered = this.signatures && this.signatures.find(item => item.key === `app-jobs-handbook`)
      if (signatureFiltered && this.student) {
        this.$set(this.signatureData, this.student.id, { signed_at: signatureFiltered.created_at, completed: true });
      }
    },

    onSignatureUpdated($event) {
      if (!this.signatureData[$event.key]) {
        this.$set(this.signatureData, $event.key, {});
      }
      this.$set(this.signatureData, $event.key, { signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null });
    },

    scrollTop: function () {
      if (window.pageYOffset > 0) {
        this.intervalId = setInterval(() => {
          if (window.pageYOffset === 0) {
            clearInterval(this.intervalId)
          }
          window.scroll(0, window.pageYOffset - 50)
        }, 5)
      }
    },
    async validateStep() {
      this.errors = {}
      let stepValid = false;

      // applicant signature validation
      if(!this.userIsStudent) {
        if (!this.signatureData[this.applicant.id]) {
          this.errors['signature_' + this.applicant.id] = {
            errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
          };
        } else if (this.signatureData[this.applicant.id] && this.signatureData[this.applicant.id].signed_at == null) {
          this.errors['signature_' + this.applicant.id] = {
            errors: [this.applicant.first_name + ' ' + this.applicant.last_name + ' must sign this form as their name appears above.'],
          };
        }
      }

      // student signature validation
      if (!this.signatureData[this.student.id]) {
        this.errors['signature_' + this.student.id] = {
          errors: [this.student.first_name + ' ' + this.student.last_name + ' must sign this form as their name appears above.'],
        };
      } else if (this.signatureData[this.student.id] && this.signatureData[this.student.id].signed_at == null) {
        this.errors['signature_' + this.student.id] = {
          errors: [this.student.first_name + ' ' + this.student.last_name + ' must sign this form as their name appears above.'],
        };
      }

      if (_.size(this.errors) == 0) {
        stepValid = await this.save()
      }

      if (!stepValid) {
        setTimeout(() => {
          this.scrollTop()
        }, 10);
      }

      return stepValid
    },

    async save() {
      let stepValid = false
      this.$emit('loading', true)
      let data = {
        signatures: this.signatureData,
      }
      await axios.put(`/api/hope/jobs/applications/${this.application.id}/step-handbook`, data)
        .then((res) => {
          this.$emit('done', res)
          this.$emit('loading', false)
          stepValid = true
        })
        .catch((err) => {
          // if (err.response.data.errors) {
          //   this.serverValidationErrors = err.response.data.errors;

          // }
          this.$emit('loading', false)
          stepValid = false
        })

      return stepValid
    },
  }
}
</script>

<style lang="scss">
.handbook-step-wrapper {
  .uk-card-primary {
    color: white;
    background-color: #0f7ae5;
    padding: 40px;
    font-size: 1.2em;
    border-radius: 6px;
  }
}
</style>
